import React from "react";

function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer>
      <div>
        <p>© {year}. Crafted with love & code by Aflah</p>
      </div>
    </footer>
  );
}

export default Footer;
